/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PaginationModel from './PaginationModel';
import PlatformDto from './PlatformDto';

/**
 * The SearchingQueryResponseModelPlatformDto model module.
 * @module model/SearchingQueryResponseModelPlatformDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelPlatformDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelPlatformDto</code>.
     * @alias module:model/SearchingQueryResponseModelPlatformDto
     */
    constructor() { 
        
        SearchingQueryResponseModelPlatformDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelPlatformDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelPlatformDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelPlatformDto} The populated <code>SearchingQueryResponseModelPlatformDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelPlatformDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [PlatformDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelPlatformDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/PlatformDto>} result
 */
SearchingQueryResponseModelPlatformDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelPlatformDto;

